import {useEffect} from 'react'

import type {MutableRefObject} from 'react'

export type UseScrollIntoViewParams = {
  ref: MutableRefObject<HTMLElement | null>
  shouldScroll: boolean
}

/**
 * Motion-safe hook to scroll an element into view when shouldScroll changes to true
 * @param ref
 * @param shouldScroll
 */
export const useScrollIntoViewEffect = ({ref, shouldScroll}: UseScrollIntoViewParams): void => {
  useEffect(() => {
    if (shouldScroll && ref.current !== null) {
      const hasReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
      const scrollBehavior: ScrollBehavior = hasReducedMotion.matches ? 'instant' : 'smooth'
      ref.current.scrollIntoView({behavior: scrollBehavior})
    }
  }, [ref, shouldScroll])
}
